import { render, staticRenderFns } from "./WorkTaskVerifyTab.vue?vue&type=template&id=20da650e"
import script from "./WorkTaskVerifyTab.vue?vue&type=script&lang=ts"
export * from "./WorkTaskVerifyTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports